<template>
  <div :class="classNames">
    <NrIcon name="wrench" />
    <span class="nr-pill--text shim-pill">{{ label }}</span>
  </div>
</template>

<script lang="ts">
import NrIcon from '../NrIcon/NrIcon.vue'

export default {
  name: 'NrPill',
  props: {
    label: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'normal'
    },
    pillColor: {
      type: String,
      default: 'black'
    }
  },
  components: {
    NrIcon
  },
  computed: {
    classNames() {
      const pillClasses = [
        'nr-pill',
        `nr-pill--${this.size}`,
        `nr-pill--${this.pillColor}`
      ]

      return pillClasses
    }
  }
}
</script>
<style lang="scss">
@import '../../styles/tokens/tokens.scss';
.nr-pill {
  background-color: $color-purple-110;
  color: $color-white;
  border-radius: $border-radius-medium;
  display: inline-flex;
  align-items: center;
  font-weight: $font-weight-semibold;

  .shim-pill {
    margin-left: $spacing-8;
    margin-right: $spacing-8;
  }

  &.nr-pill--small {
    font-size: $font-size-1;
    height: $font-lineheight-2;
    padding: $spacing-none $spacing-6;
    align-items: center;
    .nr-icon {
      font-size: $font-size-1;
      width: 12px;
    }
  }

  &.nr-pill--normal {
    font-size: $font-size-3;
    height: $font-lineheight-3;
    padding: $spacing-none $spacing-6;
    .nr-icon {
      margin: $spacing-6 $spacing-6;
      font-size: $font-size-3;
      width: 14px;
    }
  }

  &.nr-pill--large {
    font-size: $font-size-5;
    height: $font-lineheight-5;
    padding: $spacing-none $spacing-8;
  }

  &.nr-pill--gray {
    background-color: $color-gray-40;
    color: $color-purple-110;
  }

  // decided to comment all others color scheme and left only black and gray, and uncomment if we need
  //&.nr-pill--yellow {
  //  background-color: $color-yellow-100;
  //  color: $color-purple-110;
  //}
  //
  //&.nr-pill--green {
  //  background-color: $color-green-100;
  //  .nr-button {
  //    color: $color-white;
  //  }
  //}
  //
  //&.nr-pill--blue {
  //  background-color: $color-blue-100;
  //  .nr-button {
  //    color: $color-white;
  //  }
  //  color: $color-white;
  //}
  //
  //&.nr-pill--purple {
  //  background-color: $color-purple-100;
  //  .nr-button {
  //    color: $color-white;
  //  }
  //}
  //
  //&.nr-pill--red {
  //  background-color: $color-red-100;
  //  .nr-button {
  //    color: $color-white;
  //  }
  //}

  @media (max-width: 1210px) {
    .nr-pill--text {
      display: none;
    }
  }
}
</style>
